import moment from 'moment';
import 'moment/locale/zh-cn';
import { crudRequest } from '@/services/api';

const mergeAndStructure = (parentArray, childArray, key) => {
  return parentArray.map(parentItem => {
    const matchingItems = childArray.filter(childItem => childItem[key] === parentItem.originSite);
    return {
      ...parentItem,
      ...(matchingItems.length > 0 && { children: matchingItems }),
    };
  });
};

function generateArray(date) {
  const array = [];
  for (let i = 0; i < 3; i++) {
    const currentDate = moment(date).add(i - 2, 'days');
    const item = {
      title: currentDate.format('dddd'),
      dataIndex: `day${Math.abs(i - 3)}`,
      align: 'center',
      width: 50,
      ellipsis: true,
    };
    array.unshift(item);
  }
  return array;
}

const currentDate = moment()
  .add(-1, 'day')
  .format('YYYY-MM-DD');

export default {
  namespace: 'TransferTimes',
  state: {
    searchParams: {
      startDate: currentDate,
    },
    exportList: [],
    dataSource: [],
    expandColumns: generateArray(currentDate),
    expandedRowKeys: [],
  },

  effects: {
    *selectByPage(_, { select, put }) {
      const { searchParams } = yield select(({ TransferTimes }) => TransferTimes);
      const expandColumns = generateArray(moment(searchParams.startDate));
      yield put({
        type: 'update',
        payload: {
          expandColumns,
        },
      });
      // eslint-disable-next-line no-unused-vars
      const { code, data } = yield crudRequest(
        '/api/transfers/selectNumberOfTransfersList',
        searchParams,
        { module: 'basic' },
      );
      if (code === 1 && data && data.data) {
        const { 全国: header = [], 营运区: area = [], 分拨: location = [] } = data.data;
        let list = [];
        let expandedRowKeys = [];
        const exportList = [...header, ...area, ...location];
        if (header.length > 0 && area.length > 0 && location.length > 0) {
          list = [...header, ...mergeAndStructure(area, location, 'originManageAreaName')];
        } else if ((header.length === 0 || !header) && area.length > 0 && location.length > 0) {
          list = mergeAndStructure(area, location, 'originManageAreaName');
          expandedRowKeys = area.map(item => item.originSite);
        } else {
          list = location;
        }
        yield put({
          type: 'update',
          payload: {
            dataSource: list,
            exportList: exportList,
            expandedRowKeys: expandedRowKeys,
          },
        });
      }
    },
  },

  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
